import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote/Blockquote';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalHeader from '../../../components/ModalHeader';
import Button from '../../../components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';

export type customMailInFormsModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
}>;

const MailInForms = ({
  showModal = false,
  handleClose,
}: customMailInFormsModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} size={'xl'}>
      <ModalHeader closeButton>
        <div className="ps-lg-5 text-sm-20-lg-32">
          <h4>Mail In Forms</h4>
        </div>
      </ModalHeader>
      <ModalBody className="pt-9  text-dark-gray fw-light">
        <section className="solid-salmon-border">
          <Row>
            <Col className="text-fs-6 lh-xs pt-13 px-13">
              <div>
                In order to complete your beneficiary updates, you need to
                submit the following paperwork.
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-fs-6 lh-xs pt-1 px-13">
              <div className="lh-xs pt-3 d-flex align-items-center">
                <FontAwesomeIcon icon={light('check')} className="pe-3" />
                <span>Beneficiary Designation Authorization Form</span>
              </div>
              <div className="lh-xs pt-3 d-flex align-items-center">
                <FontAwesomeIcon icon={light('check')} className="pe-3" />
                <span>Spousal Waiver</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex flex-column bg-white px-12 pt-7">
                <Blockquote lineVariant="warning">
                  <span className="text-ligther-grey pl-10">
                    Note: You have 30 Days
                  </span>
                </Blockquote>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-fs-6 lh-xs pt-10 px-13">
              <span>Submit all of the forms and copies</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex flex-column px-12 bg-white text-fs-6">
                <div className="px-11 py-7 border-start">
                  <div className="pt-7">Mail</div>
                  <div className="pt-7 lh-xs d-flex flex-column">
                    <span>Interlink</span>
                    <span>Benefits Express</span>
                    <span>P.O. Box 5241</span>
                    <span>Cherry Hill, NJ 08034-5241</span>
                  </div>
                  <div className="pt-7 lh-xs d-flex flex-column">
                    <span>Overnight Delivery</span>
                    <span>Benefits Express Employee Service Center</span>
                    <span>101 Woodcrest Road</span>
                    <span>Cherry Hill, NJ 08003</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-fs-6 lh-xs pt-10 px-13">
              <div>
                <span>Review</span>
                <p>Once your completed paperwork has been received it will be
                reviewed. If there are any problems with the paperwork you will
                be notified...</p>
              </div>
            </Col>
          </Row>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary-outline" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MailInForms;
